<template>
  <v-dialog :value="value" max-width="800" scrollable @input="$emit('input', $event)">
    <v-card class="bundle_dialog">
      <v-card-title class="bundle_dialog__title">
        <span>{{ $t("TITLES.tax_invoice") }}</span>
        <v-spacer />
        <v-btn icon @click="$emit('input', false)">
          <i class="fal fa-times"></i>
        </v-btn>
      </v-card-title>

      <v-card-text ref="invoiceContent">
        <div v-if="loading" class="text-center py-5">
          <v-progress-circular indeterminate color="primary" size="40" />
        </div>

        <div v-else-if="invoiceData" class="invoice_wrapper pa-4">
          <div class="text-center mb-4">
            <h4>{{ $t("TITLES.tax_invoice") }}</h4>
            <div v-if="invoiceData.qr_code" class="my-3">
              <img :src="invoiceData.qr_code" style="max-width: 150px" />
            </div>
          </div>

          <v-divider class="mb-3" />

          <v-row>
            <v-col cols="12" md="6">
              <div class="info_row">
                <span class="info_row__label">{{ $t("PLACEHOLDERS.invoice_serial") }}</span>
                <span class="info_row__value">{{
                  invoiceData.serial_number || invoiceData.id || "-"
                }}</span>
              </div>
              <div class="info_row">
                <span class="info_row__label">{{ $t("PLACEHOLDERS.invoice_date") }}</span>
                <span class="info_row__value">{{ invoiceData.date || "-" }}</span>
              </div>
              <div class="info_row">
                <span class="info_row__label">{{ $t("PLACEHOLDERS.invoice_time") }}</span>
                <span class="info_row__value">{{ invoiceData.time || "-" }}</span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info_row">
                <span class="info_row__label">{{ $t("PLACEHOLDERS.package_number") }}</span>
                <span class="info_row__value">{{ invoiceData.package_number || "-" }}</span>
              </div>
              <div class="info_row">
                <span class="info_row__label">{{ $t("PLACEHOLDERS.client_name") }}</span>
                <span class="info_row__value">{{ invoiceData.client_name || "-" }}</span>
              </div>
              <div class="info_row">
                <span class="info_row__label">{{ $t("PLACEHOLDERS.client_mobile") }}</span>
                <span class="info_row__value" dir="ltr">{{
                  invoiceData.client_mobile || "-"
                }}</span>
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-3" />

          <v-row>
            <v-col cols="12" md="6">
              <div class="info_row">
                <span class="info_row__label">{{ $t("PLACEHOLDERS.driver_name") }}</span>
                <span class="info_row__value">{{ invoiceData.driver_name || "-" }}</span>
              </div>
              <div class="info_row" v-if="invoiceData.dp_name">
                <span class="info_row__label">{{
                  $t("PLACEHOLDERS.distribution_point_name")
                }}</span>
                <span class="info_row__value">{{ invoiceData.dp_name || "-" }}</span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info_row">
                <span class="info_row__label">{{
                  $t("PLACEHOLDERS.delivery_price_details")
                }}</span>
                <span class="info_row__value">
                  {{ invoiceData.delivery_fee || 0 }}
                  {{ $t("PLACEHOLDERS.sar_currency") }}
                </span>
              </div>
              <div class="info_row">
                <span class="info_row__label">{{ $t("PLACEHOLDERS.total_price") }}</span>
                <span class="info_row__value font-weight-bold">
                  {{ invoiceData.total_price || 0 }}
                  {{ $t("PLACEHOLDERS.sar_currency") }}
                </span>
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-3" />

          <h6 class="section_title mb-3">{{ $t("TITLES.profit_breakdown") }}</h6>
          <v-row>
            <v-col cols="12" sm="4">
              <div class="profit_card">
                <p class="text-muted mb-1 text-caption">{{ $t("PLACEHOLDERS.driver_profit") }}</p>
                <h5 class="mb-0 text-success">
                  {{ invoiceData.driver_profit || 0 }}
                  {{ $t("PLACEHOLDERS.sar_currency") }}
                </h5>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              v-if="invoiceData.dp_profit !== undefined && invoiceData.dp_profit !== null"
            >
              <div class="profit_card">
                <p class="text-muted mb-1 text-caption">{{
                  $t("PLACEHOLDERS.distribution_point_profit")
                }}</p>
                <h5 class="mb-0 text-info">
                  {{ invoiceData.dp_profit || 0 }}
                  {{ $t("PLACEHOLDERS.sar_currency") }}
                </h5>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="profit_card">
                <p class="text-muted mb-1 text-caption">{{ $t("PLACEHOLDERS.system_profit") }}</p>
                <h5 class="mb-0" style="color: var(--main_theme_clr)">
                  {{ invoiceData.system_profit || 0 }}
                  {{ $t("PLACEHOLDERS.sar_currency") }}
                </h5>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn text @click="$emit('input', false)">
          {{ $t("BUTTONS.close") }}
        </v-btn>
        <v-btn
          v-if="invoiceData"
          color="success"
          depressed
          @click="$emit('download')"
        >
          <i class="fal fa-download mr-1"></i>
          {{ $t("BUTTONS.download_pdf") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BundleInvoiceDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    invoiceData: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.bundle_dialog {
  &__title {
    background-color: var(--very_light_theme_clr);
    color: var(--theme_text_clr);
    border-bottom: 1px solid var(--border_clr);
  }
}

.info_row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;

  &__label {
    color: var(--light_gray_clr);
    min-width: 130px;
  }

  &__value {
    color: var(--theme_text_clr);
    font-family: $medium_font;
  }
}

.section_title {
  color: var(--main_theme_clr);
  font-family: $semi_bold_font;
}

.invoice_wrapper {
  border: 1px solid var(--border_clr);
  border-radius: 10px;
  background-color: var(--theme_second_bg_clr);
}

.profit_card {
  background-color: var(--theme_main_bg_clr);
  border: 1px solid var(--border_clr);
  border-radius: 10px;
  text-align: center;
  padding: 14px;
}
</style>
